module.exports = __webpack_public_path__ + "img/all.a03164da.jpg";